import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import sr from './sr'

Vue.use(VueI18n)

// Ready translated locale messages
const messages = {
  en: en,
  sr: sr
}

const i18n = new VueI18n({
  locale: 'sr', // set locale
  messages // set locale messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js